import { HostListener, Input, OnInit, Directive, Optional, ElementRef } from '@angular/core';

import { CollapseContainerDirective } from './collapse-container.directive';
import { CollapseBodyDirective } from './collapse-body.directive';

@Directive({
  selector: '.collapse-header'
})
export class CollapseHeaderDirective extends CollapseBodyDirective implements OnInit {

  private container: CollapseContainerDirective;
  //  tslint:disable-next-line:no-input-rename
  @Input('header-key') headerKey: string = null;

  constructor(
    private el: ElementRef,
    @Optional() container: CollapseContainerDirective) {
    super(container);
    this.container = container;
  }

  ngOnInit() {
    if (this.container) {
      this.container.setHeaderKey(this.headerKey ?? this.el.nativeElement.innerText);
    }
  }

  @HostListener('click', ['$event.target'])
  onClick() {
    if (this.container) {
      this.container.toggle();
    }
  }
}
